<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">ROUTE MARSHALS</h3>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="marshals"
              :search="search"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <tr class="pointer" @click="toroute(props.item.id)">
                  <td>
                    <h3 class="font-weight-regular" v-text="props.item.full_name"></h3>
                  </td>
                  <td v-text="props.item.state"></td>
                  <td v-text="props.item.staff_id"></td>
                  <td v-text="props.item.phone"></td>
                  <td class="text-xs-center" v-text="convertUTCTime(props.item.last_login)"></td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ search }}" route marshal has no results.</v-alert>
            </v-data-table>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import AdminLayout from "../../layouts/admin"
import utils from "@/common/utils"
import { mapState } from "vuex"
import { FETCH_MARSHALS } from "../../store/actions/ptspAdmin"

export default {
  name: "Admin",
  data() {
    return {
      page_title: "",
      getDate: new Date(),
      search: "",
      headers: [
        {
          text: "Route Marshal",
          align: "left",
          value: "full_name"
        },
        { text: "State", value: "state" },
        { text: "Card No", sortable: true, value: "staff_id" },
        { text: "Phone", value: "phone" },
        { text: "Logged In", align: "center", value: "last_login" }
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      pagination: {
        rowsPerPage: 25
      },
    }
  },
  computed: {
    ...mapState({
      marshals: state => state.admin.marshals
    })
  },
  methods: {
    toroute(route) {
      this.$router.push(`/admin/route-marshals/${route}`)
    },
    convertUTCTime(utcTime) {
      if (utcTime) return utils.convertUTCTime(utcTime)
    },
    
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  },
  mounted() {
    this.$store.dispatch(FETCH_MARSHALS)
  }
}
</script>

